import { Link } from 'react-router-dom';

const reasons = [
  { icon: 'ri-timer-flash-line', title: 'Intervention 24/48h', desc: 'Nous nous déplaçons rapidement dans tout le 15ᵉ. Votre confort n\'attend pas.', color: 'bg-brand-accent' },
  { icon: 'ri-file-text-line', title: 'Devis gratuit', desc: 'Devis détaillé sans engagement. Prix fixe après diagnostic. Pas de surprise.', color: 'bg-brand-gradientFrom' },
  { icon: 'ri-shield-check-line', title: 'Société assurée', desc: 'Responsabilité civile professionnelle. Vous êtes protégé, nous sommes couverts.', color: 'bg-brand-gradientTo' },
  { icon: 'ri-map-pin-line', title: 'Pas de frais de déplacement', desc: 'Aucun frais caché dans le 15ᵉ. Intervention chez vous ou en copropriété.', color: 'bg-brand-accent' },
  { icon: 'ri-team-line', title: 'Techniciens salariés', desc: 'Pas de sous-traitance. Tous nos techniciens sont formés PVC, Alu, Bois et volets.', color: 'bg-brand-gradientFrom' },
  { icon: 'ri-building-line', title: 'Ancrage local', desc: 'Nous connaissons chaque quartier du 15ᵉ : Vaugirard, Grenelle, Javel, Beaugrenelle…', color: 'bg-brand-gradientTo' },
];

export default function WhyUsSection() {
  return (
    <section className="py-14 md:py-20 bg-[#e6f7f5]">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-brand-dark mb-3 font-heading">
            Pourquoi choisir DF PRO ?
          </h2>
          <p className="text-sm md:text-base text-brand-text/60">
            L'expertise d'un artisan local, la rigueur d'une entreprise assurée
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {reasons.map((reason, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 p-5 md:p-6 bg-white rounded-2xl border border-brand-mint/60 hover:border-brand-accent/30 transition-all hover:-translate-y-0.5 shadow-sm"
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl ${reason.color} text-white flex-shrink-0`}>
                <i className={`${reason.icon} text-lg md:text-xl`}></i>
              </div>
              <div>
                <h3 className="text-sm md:text-base font-bold text-brand-dark mb-1">{reason.title}</h3>
                <p className="text-xs md:text-sm text-brand-text/60 leading-relaxed">{reason.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link to="/qui-sommes-nous/" className="btn-outline text-sm">
            En savoir plus sur DF PRO <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}